import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.features.getReportUser.UseReportUserPresenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  loadErrorFallbackMessage: {
    id: `${scope}.loadErrorFallbackMessage`,
    defaultMessage: 'Unable to load the user.',
  },
})
